import React from 'react';

function Icon({glyph, width = 24, height = 24, className = 'icon', icon}){

    if(!glyph && !!icon) {
        glyph = require(`../../../images/icons/${icon}`);
    }

    return (
        <svg className={className} width={width} height={height}>
            <use xlinkHref={glyph} />
        </svg>
    );
}

export default Icon;


// WEBPACK FOOTER //
// ./app/components/shared/Icon.jsx